import axios from 'axios'

import { getCookie, deleteCookie, setCookie } from '../utils/manageCookie'

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 40_000,
})

// 토큰 관리 변수
let isRefreshing = false
let refreshQueue = []

/**
 * API 요청 시마다 액세스 토큰을 실어 보내도록 한다.
 */
api.interceptors.request.use(
  function (config) {
    const user = getCookie('akive_user')
    const pathList = config.url.split('/')
    if (user && pathList[pathList.length-1] !== 'tokens') config.headers.Authorization = `Bearer ${user.accessToken}`
    return config
  }
)

/**
 * 정상 응답일 경우 응답을 그대로 리턴한다.
 * 단, 액세스 토큰이 만료 됐을 경우 리프레시 토큰을 통해 토큰을 재발행 하도록 한다.
 */
api.interceptors.response.use(
  function (response) {
    return response
  },
  async function (error) {
    const originalReq = error.config

    if (typeof error.response.data === 'string') {
      error.response.data = JSON.parse(error.response.data)
    }

    if (error.response && error.response.status === 401
      && error.response.data.message === '만료된 액세스 토큰입니다.'
      && ! originalReq._retry) {

      // 이미 액세스 토큰 갱신이면, 새 요청을 큐에 추가하고 대기
      if (isRefreshing) {
        return new Promise((resolve) => {
          refreshQueue.push((newAccessToken) => {
            originalReq.headers.Authorization = `Bearer ${newAccessToken}`
            resolve(api.request(originalReq))
          })
        })
      }

      // 토큰 갱신 플래그 설정
      isRefreshing = true
      originalReq._retry = true

      try {
        // 액세스 토큰이 만료됐을 경우 리프레시 토큰을 통해 재발행
        let user = getCookie('akive_user')
        const newToken = await api.post(`/users/${user.nickname}/tokens`
          , {}
          , { headers: { Authorization: `Bearer ${user.refreshToken}` }})
          .then(result => result?.data)

        if (newToken) {
          // 보류 중인 요청들을 새로운 토큰으로 다시 실행
          refreshQueue.forEach((callback) => callback(newToken.accessToken))
          refreshQueue = []

          user = { ...user, ...newToken }
          setCookie('akive_user', user, 30, 'd')

          // 새로 발급 받은 토큰으로 원래 하려던 API 요청 시도
          originalReq.headers.Authorization = `Bearer ${newToken.accessToken}`
          return api.request(originalReq)
        }
      } catch (e) {
        console.error(e)
        return Promise.reject(error)
      } finally {
        isRefreshing = false
      }
    } else if (error.response && error.response.status === 401
      && error.response.data.message === '만료된 리프레시 토큰입니다.') {
      deleteCookie('akive_user')
      window.location.href = '/sign-in'
      return Promise.reject(error)
    } else {
      return Promise.reject(error)
    }
  }
)

export default api